// ------------------------------------------------------------------------------
// TextArea - 计数值位置在输入框内部右下角，而不是外部
// author: mudas
// created: 2024-10-24
// ------------------------------------------------------------------------------

import React, { FC } from 'react';

import { TextAreaProps } from 'rc-textarea/lib/interface';

import { Input } from 'antd';

import c from './index.module.css';

export interface IProps extends TextAreaProps {}

const TextArea: FC<IProps> = props => {
  return <Input.TextArea className={c['text-area']} autoSize={{ minRows: 5, maxRows: 20 }} {...props} />;
};

export default TextArea;
